import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../constants/Languages.js';
import Error505Page from '../components/Error505Page.js';

const LoadingError = ({ clang }) => {
    return (
        <div className="loading__error">
            <Error505Page />
        </div>
    );
};

LoadingError.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(LoadingError);



// WEBPACK FOOTER //
// ./src/components/LoadingError.js